import {Component, input, OnChanges, OnInit, ChangeDetectionStrategy} from '@angular/core';

import {ExamInvolvement} from '../../../../api/models/exam-involvement';
import {StaffMember} from '../../../../api/models/staff-member';
import {Survey} from '../../../../api/models/survey';
import {User} from '../../../../api/models/user';

import {MessageService} from '../../../../api/services/message.service';
import {SurveyService} from '../../../../api/services/survey.service';
import {WaCalloutDirective, WaIconDirective} from "angular-awesome";
import {SupervisionListElementComponent} from "./supervision-list-element/supervision-list-element.component";

@Component({
    selector: 'app-supervision-list',
    templateUrl: './supervision-list.component.html',
    styleUrls: ['./supervision-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [WaCalloutDirective, WaIconDirective, SupervisionListElementComponent]
})
export class SupervisionListComponent implements OnInit, OnChanges {
  readonly user = input<User | null>(null);
  readonly survey = input<Survey | null>(null);
  readonly staffMember = input<StaffMember | null>(null);
  readonly begin = input<Date | null>(null);
  readonly end = input<Date | null>(null);
  readonly withoutStaffMember = input(false);

  totalCount: number = 0;
  supervisions: ExamInvolvement[] = [];

  constructor(private msgService: MessageService,
              private surveyService: SurveyService) {}

  ngOnInit(): void {
    this.getSupervisions();
  }

  ngOnChanges(): void {
    this.getSupervisions();
  }

  private getSupervisions(): void {
    if (!this.stateValid())
      return;

    const id = this.survey()!.id;
    const staffMember = this.staffMember();
    const staffMemberId = !!staffMember ? staffMember.id : null;
    const begin = this.begin();
    const end = this.end();

    this.surveyService.getSupervisions(
      id,
      staffMemberId,
      begin,
      end
    ).subscribe({
      next: result => {
        this.supervisions = result.data;
        this.totalCount = result.count;
      },
      error: err => {
        this.msgService.log(err.message);
        this.msgService.showSimple('Could not fetch supervision assignments.');
      }
    });
  }

  private stateValid(): boolean {
    return !!this.user() && !!this.survey() &&
          (!!this.staffMember() || this.withoutStaffMember());
  }
}
